import clipboard from "clipboard-polyfill";

export default {
  data() {
    return {
      clipboard: new clipboard.DT(),
    };
  },
  methods: {
    copyData(data) {
      try {
        if (data) {
          this.clipboard.setData("text/plain", data);
          clipboard.write(this.clipboard);
          this.$message.success("Скопировано");
        } else {
          throw new Error("Нечего копировать");
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
};
